import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ContractorAuthenticationModal from '../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../components/family-plaza/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../utils/authUtils';
import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import DeceasedPersonProfile from '../../../components/family-plaza/DeceasedPersonProfile';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';

const MemorialAlbumWritingMobile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [photoDescription, setPhotoDescription] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState('/images/default4.png');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/mobile donate/group-129.png');
  const navigate = useNavigate();


  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleMemorialPost = () => {
    navigate('/cyber-memorial-search');
  };

  const handleLetterToHeaven = () => {
    navigate('/letter-to-heaven-board-list');
  };

  const handleManagementInquiry = () => {
    navigate('/management-search');
  };

  const handleAncestralTablet = () => {
    navigate('/ancestral-tablet');
  };

  const handleRegister = async () => {
    // Validate required fields first
    if (!title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }
    
    // Check if a photo is attached (more flexible check)
    if (previewImage === '/images/default4.png' || !previewImage) {
      alert('사진을 첨부해주세요.');
      return;
    }
    
    // Check authentication status
    if (!checkModalAuthenticationStatus()) {
      setShowAuthModal(true);
      return;
    }
    
    // If authenticated and photo is attached, proceed with form submission
    try {
      const success = await saveAlbumData();
      if (success) {
        // Only navigate if the API call was successful
        navigate('/memorial-album-board-list');
      }
      // If not successful, stay on the current page (error message already shown in saveAlbumData)
    } catch (error) {
      console.error('Error in handleRegister:', error);
      alert('앨범 등록 중 오류가 발생했습니다.');
    }
  };

  const handleCancel = () => {
    navigate('/memorial-album-board-list');
  };

  const saveAlbumData = async () => {
    // Get selected person data for proper goinId and cherishId
    const selectedPersonData = localStorage.getItem('selectedPersonData'); 
    const getCherishId = localStorage.getItem('cherishId');

    let goinId = 0;
    let cherishId = 0;
    
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        goinId = parseInt(personData.goinId);
        
        // Check if cherishId exists in localStorage
        if (getCherishId) {
          try {
            const parsedCherishId = JSON.parse(getCherishId);
            cherishId = parseInt(parsedCherishId);
          } catch (parseError) {
            console.error('Error parsing cherishId:', parseError);
            cherishId = 0;
          }
        } else {
          console.warn('cherishId not found in localStorage');
          cherishId = 0;
        }
      } catch (error) {
        console.error('Error parsing selectedPersonData:', error);
        goinId = 0;
        cherishId = 0;
      }
    }
    

    
    // Validate that we have valid IDs before making API call
    if (!goinId || !cherishId) {
      alert('사용자 정보를 찾을 수 없습니다. 다시 로그인해주세요.');
      console.error('Invalid IDs - goinId:', goinId, 'cherishId:', cherishId);
      return false;
    }
      
    // Prepare data for API
    const apiData = {
      cherishId: cherishId,
      goinId: goinId,
      albumTitle: title.trim(),
      base64Image: previewImage !== '/images/default4.png' ? previewImage : '/gallery pc list/p-5070484.png'
    };
    
    
    try {
      // Create album via API
      const response = await CyberMemorialService.createMemorialAlbumEntry(apiData);
      
      if (response) {
        // Show success message
        alert('앨범이 성공적으로 등록되었습니다.');
        return true;
      } else {
        alert('앨범 등록에 실패했습니다.');
        return false;
      }
      
    } catch (error) {
      console.error('Debug - API error details:', error);
      
      // Show user-friendly error message
      if (error.response) {
        // Server responded with error status
        alert(`서버 오류가 발생했습니다. (${error.response.status})`);
      } else if (error.request) {
        // Network error
        alert('네트워크 연결을 확인해주세요.');
      } else {
        // Other error
        alert('앨범 등록 중 오류가 발생했습니다.');
      }
      
      return false;
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
        alert('업로드가 완료되었습니다.');
      };
      reader.readAsDataURL(file);
    }
  };

      const removeImage = () => {
      setSelectedFile(null);
      setPreviewImage('/images/default4.png');
    };

  const handlePhotoUpload = () => {
    // Trigger file input click
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = handleFileChange;
    fileInput.click();
  };

  const handleRemoveImage = () => {
    removeImage();
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    const isAuthenticated = checkModalAuthenticationStatus();
    
    if (isAuthenticated) {
      // If already authenticated, open photo modal directly
      setShowPhotoModal(true);
    } else {
      // If not authenticated, open auth modal first
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers for camera icon
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    // After successful authentication, open photo modal
    setShowPhotoModal(true);
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };




  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handleProfilePhotoUpload = (photoUrl) => {
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  return (
    <div className="memorial-album-writing-mobile-unique announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="사이버추모관" />
      
     
<DeceasedPersonProfile 
        handlePhotoIconClick={handlePhotoIconClick}
      />
      

      {/* Navigation Tabs */}
      <div className="memorial-album-writing-mobile-nav-tabs-unique">
        <button 
          className="memorial-album-writing-mobile-nav-tab-unique"
          onClick={() => navigate('/donate')}
        >
          <span>헌화하기</span>
        </button>
        <button 
          className="memorial-album-writing-mobile-nav-tab-unique"
          onClick={() => navigate('/memorial-post-board-list')}
        >
          <span>추모글</span>
        </button>
        <button 
          className="memorial-album-writing-mobile-nav-tab-unique memorial-album-writing-mobile-nav-tab-active-unique"
          onClick={() => navigate('/memorial-album-board-list')}
        >
          <span>추모앨범</span>
        </button>
      </div>

      {/* Memorial Album Writing Form */}
      <div className="memorial-album-writing-mobile-form-unique">
        {/* Title Input Section */}
        <div className="memorial-album-writing-mobile-title-section-unique">
          <label className="memorial-album-writing-mobile-title-label-unique">
            제목
          </label>
          <input 
            type="text" 
            className="memorial-album-writing-mobile-title-input-unique"
            placeholder=""
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* Separator */}
        <div className="memorial-album-writing-mobile-separator-unique"></div>

                 {/* Photo Attachment Section */}
         <div className="memorial-album-writing-mobile-photo-section-unique">
           <label className="memorial-album-writing-mobile-photo-label-unique">
             사진첨부
           </label>
           <div className="memorial-album-writing-mobile-photo-input-container-unique">
                           <input 
                type="text" 
                className="memorial-album-writing-mobile-photo-input-unique"
                placeholder=""
                value={photoDescription}
                onChange={(e) => setPhotoDescription(e.target.value)}
              />
                           <div className="memorial-album-writing-mobile-photo-upload-btn-unique" onClick={handlePhotoUpload}>
                <div className="memorial-album-writing-mobile-folder-search-icon-unique">
                  <img src="/images/icon.png" alt="Upload Icon" />
                  <div className="memorial-album-writing-mobile-search-overlay-unique">
                    <svg width="4" height="4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" stroke="#666" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" opacity="0.5"/>
                    </svg>
                  </div>
                </div>
              </div>
           </div>
           
                       {/* Image Preview */}
            <div className="memorial-album-writing-mobile-image-preview-unique">
              <img src={previewImage} alt="Preview" />
              <button className="memorial-album-writing-mobile-remove-image-unique" onClick={handleRemoveImage}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="4" fill="#666666"/>
                  <path d="M7 7L17 17M17 7L7 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
           
           {/* Upload Guidelines */}
           <div className="memorial-album-writing-mobile-upload-guidelines-unique">
             <ul>
               <li>최적 사진 사이즈는 100x100px입니다.</li>
               <li>한번에 업로드 가능한 파일 크기는 10MB 이하입니다.</li>
             </ul>
           </div>
         </div>

                       {/* Action Buttons */}
               <div className="memorial-album-writing-mobile-action-buttons-unique">
                 <button 
                   className="memorial-album-writing-mobile-register-button-unique"
                   onClick={handleRegister}
                 >
                   등록
                 </button>
                 <button className="memorial-album-writing-mobile-cancel-button-unique" onClick={handleCancel}>
                   취소
                 </button>
               </div>
      </div>

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handleProfilePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialAlbumWritingMobile; 
